<template>
    <div class="content">
        <div class="banner">
            <div class="banner_con">
                <div class="banner_title">思派健康保</div>
                <div class="banner_Subheading">新一代员工福利</div>
                <div class="btn_link"
                     @click="showModal">
                    联系我们
                </div>
            </div>
        </div>
        <div class="comm_title">产品特色</div>
        <div class="comm_english_title"> PRODUCT CHARACTERISTICS</div>
        <div class="pro_list">
            <div v-for=" (item,index) in this.product"
                 class="pro_li"
                 :key="index">
                <div class="pro_img"><img :src="item.img"
                         alt=""></div>
                <div class="pro_title font24">
                    <span class="pro_title_y">{{item.pro_title_y}}</span>
                    <span class="pro_title_b">{{item.pro_title_b}}</span>
                </div>
                <div class="pro_txt_list">
                    <div class="pro_txt_one">
                        <span class="one_b">{{item.one_b}}</span>
                        <span class="one_c">{{item.one_c}}</span>
                    </div>
                    <div class="pro_txt_one">
                        <span class="two_b">{{item.two_b}}</span>
                        <span class="two_c">{{item.two_c}}</span>
                    </div>
                </div>
            </div>

        </div>
        <div class="comm_title">产品优势</div>
        <div class="comm_english_title"> PRODUCT ADVANTAGE </div>
        <div class="pro_list">
            <div class="pro_good">
                <div class="pro_title">
                    <span class="pro_title_y good_title_ye">全方位</span>
                    <span class="pro_title_b"> 医疗健康服务</span>
                </div>
                <div class="good_list">
                    <div class="good_one_list">
                        <div class="good_h3">覆盖就医全流程</div>
                        <div class="good_li"
                             v-for="(item,index) in good_one_list"
                             :key="index">
                            <div class="circle"></div> {{item}}
                        </div>
                    </div>
                    <div class="good_two_list">
                        <div class="good_h3">企业专属服务团队</div>
                        <div class="good_li"
                             v-for="(item,index) in good_two_list"
                             :key="index">
                            <div class="circle"></div> {{item}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="good_img">
                <img src='@/images/p_全方位医疗@2x.png'
                     alt="">
            </div>
        </div>
        <div class="pro_list">
            <div class="up_img">
                <img src='@/images/p_重疾保障@2x.png'
                     alt="">
            </div>
            <div class="pro_good">
                <div class="pro_title">
                    <span class="pro_title_y good_title_ye"> 重疾保障</span>
                    <span class="pro_title_b"> 再升级</span>
                </div>
                <div class="good_list">
                    <div class="good_one_list">
                        <div class="good_h3">覆盖各级风险的疾病</div>
                        <div class="good_li w_196"
                             v-for="(item,index) in up_one_list"
                             :key="index">
                            <span class="circle"> {{item}}</span>
                        </div>
                    </div>
                    <div class="good_two_list">
                        <div class="good_h3">有竞争力的赔付额度</div>
                        <div class="good_li w_196"
                             v-for="(item,index) in up_two_list"
                             :key="index">
                            <div class="circle"></div> {{item}}
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="pro_list">
            <div class="">
                <div class="pro_title">
                    <span class="pro_title_y good_title_ye">费用可控</span>
                    <span class="pro_title_b"> 不能少</span>
                </div>
                <div class="good_list">
                    <div class="good_one_list">
                        <div class="good_h3">健康管理</div>
                        <div class="good_li w_196"
                             v-for="(item,index) in cost_one_list"
                             :key="index">
                            <div class="circle"></div> {{item}}
                        </div>
                    </div>
                    <div class="good_two_list">
                        <div class="good_h3">自建服务体系</div>
                        <div class="good_li w_196"
                             v-for="(item,index) in cost_two_list"
                             :key="index">
                            <div class="circle"></div> {{item}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="cost_img">
                <img src='@/images/p_费用控制@2x.png'
                     alt="">
            </div>
        </div>
        <div class="comm_title">合作伙伴</div>
        <div class="comm_english_title"> COOPERATIVE PARTNER </div>
        <div class="enterprise">
            <img src="@/images/企业logo@2x.png"
                 alt="">
        </div>

        <v-modal :visible="visible"
                 @onCloseModal="handleCloseModal"></v-modal>

    </div>
</template>

<script>
import vModal from '@/components/modal';

export default {
    name: 'home',
    components: {
        vModal
    },
    data() {
        return {
            top_show: false,
            visible: false,
            product: [
                {
                    img: require('@/images/icon_福利@2x.png'),
                    pro_title_y: '全体',
                    pro_title_b: '员工感受福利',
                    one_b: '现状：',
                    one_c: '每年接近80%的企业员工未曾享受到补充医疗保险的福利',
                    two_b: '思派健康保：',
                    two_c: '每一位员工都能享受思派专属的360°全方位的医疗健康服务团队的福利'
                },
                {
                    img: require('@/images/icon_百万医疗@2x.png'),
                    pro_title_y: '百万',
                    pro_title_b: '医疗专业保障',
                    one_b: '现状：',
                    one_c: '员工遇到重疾风险，团险的保障不能满足自身需求',
                    two_b: '思派健康保：',
                    two_c: '针对高风险重疾，提供升级版重疾保障。险责范围和赔付额度较普通团险有明显优势'
                },
                {
                    img: require('@/images/icon_控费@2x.png'),
                    pro_title_y: '稳定',
                    pro_title_b: '可控相关费用',
                    one_b: '现状：',
                    one_c: '企业主面临人均保费的逐年增长的困局',
                    two_b: '思派健康保：',
                    two_c: '依托自有医生、转诊和药房网络，与企业共同打造费用稳定可控的企业健康体系'
                }
            ],
            good_one_list: [
                '健康管理及预防筛查服务',
                '全科诊疗及咨询服务',
                '药品服务',
                '专科诊疗及第三方服务',
                'VIP专属服务'
            ],
            good_two_list: ['全科医生', '职业护士', '执业药师', '专属保险服务经理'],
            up_one_list: [
                '拥有全科医生、全国专家服务网络及药品供应网络和重疾保险',
                '全面满足预防需求、诊疗需求和重疾保障'
            ],
            up_two_list: [
                '较传统团险计划，对乙类自付和自费部分的保障有明显优势',
                '近三年在中国上市的新特药品，100%全覆盖'
            ],
            cost_one_list: [
                '通过正确健康管理手段，真正降低员工患病风险。减少企业人力/保险开支，提高生产力',
                '避免服务滥用导致的诊费偏高、赔付率恶化带来的保费上涨'
            ],
            cost_two_list: ['通过自建的转诊和药房服务体系，提升服务质量和效率，降低成本']
        };
    },
    mounted() {
        window.addEventListener('scroll', this.scrollToTop);
    },
    destroyed() {
        window.removeEventListener('scroll', this.scrollToTop);
    },
    methods: {
        showModal() {
            this.visible = true;
        },
        handleCloseModal(val) {
            this.visible = val;
        }
     
    }
};
</script>

<style lang="scss" scoped>
.content{ background: #fff;}
.banner {
    background: url('../../images/banner@2x.png') no-repeat 50%;
    height: 400px;
    background-size: 1920px 400px;
      background-position: center center;

}
.banner_con {
    margin-left: 300px;
    padding-top: 66px;
    width: 1000px;
    margin:0px auto;
    padding-left: 100px;

}
.banner_title {
    font-size: 50px;
    font-family: 'DF King Gothic SC24';
    font-weight: 300;
    color: #000;
}
.banner_Subheading {
    margin: 10px 0px 30px;
    font-size: 32px;
    font-family: 'DF King Gothic SC24';
    font-weight: 300;
    color: #000;
}

.comm_title {
    margin-top: 100px;

    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #333;
    font-size: 26px;
    font-family: 'DF King Gothic SC24';
    font-weight: 500;
    position: relative;
    z-index: 1;
}
.comm_english_title {
    margin-top: -24px;
    margin-bottom: 45px;
    color: #e2e4e8;
    opacity: 0.4;
    font-size: 30px;
    font-weight: bold;
    height: 30px;
    font-family: 'Helvetica';
    text-align: center;
}
.pro_list {
    width: 1000px;
    display: flex;
    justify-content: space-around;
    margin: 0px auto;
}
.pro_good {
    margin-top: 90px;
}
.pro_li {
    width: 270px;
    text-align: center;
    box-shadow: 0px 2px 30px 0px rgba(41, 26, 204, 0.08);
    border-radius: 4px;
    padding: 16px 20px 20px;
}
.pro_title {
    font-size: 24px;
    margin-top: 7px;
    margin-bottom: 30px;
}
.font24 {
    font-size: 20px;
    margin-bottom: 10px;
}
.good_h3 {
    font-size: 20px;
    color: #333;
    margin-bottom: 10px;
  
}
.pro_title_y {
    color: #f37828;
}
.pro_title_b {
    color: #333333;
}
.pro_txt_one {
    font-size: 14px;
    text-align: left;
    line-height: 26px;
}
.good_title_ye {
    border-bottom: 3px solid #f87942;
    padding-bottom: 16px;
    border-radius: 2px;
}
.one_b,
.two_b {
    color: #333;
}
.one_c {
    color: #62636c;
}

.pro_img img {
    width: 120px;
    height: 120px;
}
.good_img img {
    width: 440px;
    height: 440px;
}
.good_list {
    width: 100%;
    display: flex;
    justify-content: space-between;
}
.good_li {
    line-height: 26px;
    color: #333;
    font-size: 14px;
    display: flex;
    margin-bottom: 10px;
}
.w_196 {
    width: 216px;
}
.circle {
    position: relative;
    padding-left: 14px;
 

    &:before {
        content: '';
        position: absolute;
        width: 6px;
        height: 6px;
        background: #f76d32;
        left: 0;
        border-radius: 50%;
        top: 12px;
        margin-right: 10px;
    }
}
.good_one_list,
.good_two_list {
    margin-right: 32px;
}
.up_img {
    margin-right: 42px;
}
.up_img img {
    width: 440px;
    height: 440px;
}
.cost_img img {
    width: 440px;
    height: 440px;
    margin-top:-100px
}
.enterprise {
    text-align: center;
    padding-bottom: 192px;
}
.enterprise img {
    width: 1000px;
    height: 80%;
}
.btn_link {
    cursor: pointer;
    width: 140px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #f87942;
    border-radius: 30px;
    color: #fff;
    font-size: 16px;
}
// .top_me {
//     position: fixed;
//     right: 0px;
//     bottom: 20%;
// }
// .go_top,
// .link_me {
//     cursor: pointer;
//     width: 74px;
//     height: 74px;
//     box-shadow: 0px 4px 18px 2px rgba(248, 121, 66, 0.2);
//     color: #fff;
//     font-size: 16px;
//     font-weight: 500;
//     text-align: center;
// }
// .link_me {
//     background: #fd8753;
//     border-radius: 8px 0px 0px 8px;
//     margin-bottom: 8px;
// }
// .link_me img,
// .go_top img {
//     width: 42px;
//     height: 42px;
//     margin: 10px 22px 7px;
// }
// .go_top {
//     background: #ff9b6f;
//     border-radius: 8px  0px 0px 8px;
//     opacity: 0.8;
// }
</style>